// extracted by mini-css-extract-plugin
export default {"homeproduct__wrapper":"home_homeproduct__wrapper__3le7G","handwear__wrapper":"home_handwear__wrapper__wor5A"};